import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MessageSquare } from 'lucide-react';

const NotificationWidget = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    loadCount();
    const interval = setInterval(loadCount, 300000);
    return () => clearInterval(interval);
  }, []);

  const loadCount = async () => {
    try {
      const response = await axios.get('/notifications/unread-count');
      setCount(response.data?.count || 0);
    } catch (error) {
      // Silently fail - don't spam console
    }
  };

  const hasMany = count > 9;

  return (
    <Link
      to="/notifications"
      className={`bg-white border rounded-lg p-3 sm:p-6 shadow-sm border-l-4 hover:shadow-md transition-shadow block relative overflow-hidden ${
        count > 0 ? 'border-l-red-500 border-red-200' : 'border-l-slate-400 border-slate-200'
      } ${hasMany ? 'notification-urgent' : ''}`}
      data-testid="action-notifications"
    >
      {hasMany && <div className="absolute inset-0 bg-red-500/5 animate-ping-slow rounded-lg pointer-events-none" />}
      <div className="flex items-center space-x-3 sm:space-x-4 relative z-10">
        <div className={`relative p-2 sm:p-3 rounded-lg flex-shrink-0 ${hasMany ? 'bg-red-500/20' : count > 0 ? 'bg-red-500/10' : 'bg-slate-100'}`}>
          <MessageSquare className={`h-5 w-5 sm:h-6 sm:w-6 ${count > 0 ? 'text-red-500' : 'text-slate-500'} ${hasMany ? 'animate-notification-bell' : ''}`} />
          {count > 0 && (
            <span className={`absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full shadow-lg shadow-red-500/50 flex items-center justify-center ${
              hasMany ? 'w-7 h-7 text-sm animate-notification-bounce' : 'w-5 h-5 animate-pulse'
            }`}>
              {count > 9 ? '9+' : count}
            </span>
          )}
        </div>
        <div className="min-w-0">
          <p className={`text-sm sm:text-lg font-semibold truncate ${hasMany ? 'text-red-600 animate-pulse' : count > 0 ? 'text-red-600' : 'text-[#0F172A]'}`}>
            Messagerie
          </p>
          <p className={`text-xs sm:text-sm ${count > 0 ? 'text-red-500 font-medium' : 'text-slate-600'}`}>
            {count > 0 ? `${count} non lue${count > 1 ? 's' : ''}` : 'Aucune nouvelle'}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default NotificationWidget;
